import React, { useEffect, useState } from "react";
import { Menu, Dropdown } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import { useRedirect } from "pages/hooks/redirect";
import { bindingWx } from "apis/user";
import { getServices, getColorValue } from "apis/admin";
import ScreenQr from "pages/components/ScreenQr";
import { showMessage } from "utils";
import * as qs from "query-string";
import CommonIcon from "pages/components/commonIcon";
import { userLogout } from "pages/myutils/user";
import { removeRequestToken } from "pages/myutils/request";
import { rightHost } from "components/common";
import cookies from "js-cookie";
import { Steps } from "intro.js-react";
import { BasicUrl, WenJuanUrl } from "config/config";
import FogetPass from "../fogetPass/index";
import Alerts from "./qrAlert";
import InfoAlert from "./userInfoAlert";
import BindingAleft from "./bindingAlert";
import ChangeNameAlert from "./changeNameAlert";
import ChangeRole from "./changeRole";
import Rz from "../authentication/alert";
import RegFrirstAlerts from "../../../user/workbench/home";
import "./index.css";

const { axios } = window;
export default function UserBox({ user }) {
  const { companyid, forwardUrl } = qs.parse(window.location.search);
  const token = cookies.get("shorcuts");
  const [qr, setQr] = useState(null);
  const [imgShow, setImgShow] = useState(false);
  const [redirect, setTo] = useRedirect();
  const [time, setTime] = useState(null);
  const [visible, setVisible] = useState(false);
  const [alertBol, setAlertBol] = useState(false);
  //  1 微信 2 手机
  const [alertBolType, setAlertBolType] = useState(1);
  const [changeNameBol, setChangeNameBol] = useState(false);
  const [infoAlertBol, setInfoAlertBol] = useState(false);
  const [bindingBol, setBndingBol] = useState(true);
  //  认证开关
  const [rzBol, setrzBol] = useState(false);
  // 认证相关  ， title  、 公司id
  const [rzInfo, setRzInfo] = useState({
    title: null,
    companyId: null
  });
  const [roleBol, setRoleBol] = useState(false);
  const [pollingData, setPolling] = useState(null);
  const [getOutURL, setOutURL] = useState("");
  //  判断是否显示绑定type  1 不显示  2 显示
  const [bindingBolType, setBindingBolType] = useState(2);
  // 新手指导左侧关闭
  const [xinYinBoxBol, setxinYinBoxBol] = useState(!cookies.get("dingzhiBol"));
  const [regFirstBol, setRegFirstBol] = useState(
    cookies.get("regFirstBol") && !cookies.get("dingzhiBol")
  );
  // console.log(cookies.get("regFirstBol"));
  // 新手指导
  const [steps, setSteps] = useState([]);
  const [stepsBol, setStepsBol] = useState(false);
  // 修改手机号时，可以关闭弹窗
  const [infoAlertIsEdit, setInfoAlertIsEdit] = useState(false);

  let arr;
  // 新手指导
  const newUserPonit = ower => {
    const timer = setInterval(() => {
      if (
        document.getElementsByClassName("ant-dropdown-link")[0] ||
        document.getElementsByClassName("oneShenfen")[0]
      ) {
        if (ower) {
          setSteps([
            {
              element: ".ant-dropdown-link",
              intro: "您可在此处创建企业或切换企业使用调研工厂"
            },
            {
              element: ".jrButton",
              intro:
                "您可以通过此处进入企业管理后台，管理企业员工、企业钱包充值等功能"
            },
            {
              element: ".servicebox1",
              intro:
                "调研工厂提供的产品服务包括明察暗访、网络调查、面对面访问、调研培训、材料申报系统，点击进入即可使用"
            },
            {
              element: ".servicebox2",
              intro:
                "调研工厂提供的试用功能包括：任务广场、企业管理工具、数据分析工具，点击进入即可使用"
            },
            {
              element: ".user-box",
              intro:
                "点击头像可查看用户个人中心，您可在此新建企业/切换企业、修改个人信息、绑定微信、修改密码、退出等操作。",
              position: "left",
              highlightClass: "userToop"
            },
            {
              element: ".gerenRz",
              intro: "您可以通过此处进行个人用户认证",
              position: "left",
              highlightClass: "gerenRzToop"
            },
            {
              element: ".companyInfo",
              intro: "您可以通过此处进行企业身份认证，认证成功后图标会点亮",
              position: "left",
              highlightClass: "qiyeRzToop"
            },
            {
              element: ".helpBox",
              intro: "您可以通过此处进入帮助中心查看产品服务使用说明",
              highlightClass: "helpToop",
              position: "left"
            }
          ]);
        } else {
          setSteps([
            {
              element: document.getElementsByClassName("ant-dropdown-link")[0]
                ? ".ant-dropdown-link"
                : ".oneShenfen",
              intro: "您可在此处创建企业或切换企业使用调研工厂",
              hintAnimation: false
            },
            {
              element: ".servicebox1",
              intro:
                "调研工厂提供的产品服务包括明察暗访、网络调查、面对面访问、调研培训、材料申报系统，点击进入即可使用"
            },
            {
              element: ".servicebox2",
              intro:
                "调研工厂提供的试用功能包括：任务广场、企业管理工具、数据分析工具，点击进入即可使用"
            },
            {
              element: ".user-box",
              intro:
                "点击头像可查看用户个人中心，您可在此新建企业/切换企业、修改个人信息、绑定微信、修改密码、退出等操作。",
              position: "left",
              highlightClass: "userToop"
            },
            {
              element: ".companyInfo",
              intro: "您可以通过此处进行个人用户认证",
              position: "left",
              highlightClass: "gerenRzToop"
            },
            {
              element: ".helpBox",
              intro: "您可以通过此处进入帮助中心查看产品服务使用说明",
              highlightClass: "helpToop",
              position: "left"
            }
          ]);
        }
        setStepsBol(true);
        clearInterval(timer);
      }
    }, 200);
  };
  const [getLoginInFunction, setLoginInFunction] = useState("");
  // 获取企业定制相关信息
  const getDingzhiInfo = () => {
    getServices({ companyId: companyid }).then(res => {
      console.log(res);
      // 申报吧
      const out = res.filter(item => item.serviceType === -1);
      setOutURL(out[0].serviceDomain);
    });
  };
  // 获取配置内容
  const getConfigInfo = () => {
    getColorValue(companyid, 0).then(data => {
      console.log(data);
      if (data.A1) {
        setLoginInFunction(data.A85.value);
      }
    });
  };
  useEffect(() => {
    if (companyid !== undefined) {
      getDingzhiInfo();
      getConfigInfo();
      if (!cookies.get("dingzhiBol")) {
        document.title = `${user?.self?.company?.companyName ||
          "个人用户"}__调研工厂`;
      }
    }
  }, [companyid]);
  // 定制企业主子账户判断
  const judgeAccount = it => {
    // alert(it);
    if (it === 2) {
      window.location.href = `/login?type=childLogin&companyid=${companyid}`;
    } else {
      window.location.href = `/login?companyid=${companyid}`;
    }
  };
  // 非定制企业账户判断
  // 退出登录
  function logout() {
    const urlCompanyid = qs.parse(window.location.search).companyid;
    console.log(cookies.get("shorcuts"), urlCompanyid);
    const staffType = 1; // 获取当前账号信息 1 为普通账号 2为子账号;
    console.log("urlCompanyid", urlCompanyid);

    return new Promise((resolve, reject) => {
      if (urlCompanyid) {
        axios
          .get(`/staff/info/company?companyId=${urlCompanyid}`)
          .then(({ status, data }) => {
            console.log("status,data", status, data);
            if (status === 200) {
              // staffType = data.staffType;
              resolve(data.staffType);
            } else {
              reject();
            }
          });
      } else {
        resolve(staffType);
      }
    }).then(staffType => {
      axios.get("/customer/removeToken").then(data => {
        if (window.location.href.indexOf("mymymanager") !== -1) {
          window.location.pathname = "/mymymanager";
        } else if (cookies.get("dingzhiBol")) {
          // alert(getOutURL);
          getOutURL === BasicUrl.test || getOutURL === BasicUrl.production
            ? judgeAccount(staffType)
            : (window.location.href = getOutURL);
        } else if (cookies.get("jiluCompanyid")) {
          window.location.href = `/login?companyid=${
            cookies.get("jiluCompanyid") === "undefined"
              ? companyid
              : cookies.get("jiluCompanyid")
          }`;
        } else if (staffType === 2) {
          window.location.href = `/newlogin?loginType=childlogin&companyid=${companyid}`;
        } else if (companyid !== 0) {
          companyid === undefined
            ? (window.location.href = `/newlogin`)
            : (window.location.href = `/newlogin?companyid=${companyid}`);
        } else {
          // window.location.href = `/login?companyid=${0}`;
          window.location.href = `/newlogin`;
        }
        userLogout();
        removeRequestToken();
        cookies.remove("dingzhiBol");
        cookies.remove("jiluCompanyid");
      });
    });

    // axios
    //   .get(`/staff/info/company?companyId=${urlCompanyid}`)
    //   .then(({ status, data }) => {
    //     console.log("status,data", status, data);
    //     if (status === 200) {
    //       staffType = data.staffType;
    //     }
    //   })
    //   .then(() => {
    //     axios.get("/customer/removeToken").then(data => {
    //       if (window.location.href.indexOf("mymymanager") !== -1) {
    //         window.location.pathname = "/mymymanager";
    //       } else if (cookies.get("dingzhiBol")) {
    //         // alert(getOutURL);
    //         getOutURL === BasicUrl.test || getOutURL === BasicUrl.production
    //           ? judgeAccount(staffType)
    //           : (window.location.href = getOutURL);
    //       } else if (cookies.get("jiluCompanyid")) {
    //         window.location.href = `/login?companyid=${
    //           cookies.get("jiluCompanyid") === "undefined"
    //             ? companyid
    //             : cookies.get("jiluCompanyid")
    //         }`;
    //       } else if (staffType === 2) {
    //         window.location.href = `/newlogin?loginType=childlogin&companyid=${companyid}`;
    //       } else if (companyid != 0) {
    //         companyid === undefined
    //           ? (window.location.href = `/newlogin`)
    //           : (window.location.href = `/newlogin?companyid=${companyid}`);
    //       } else {
    //         // window.location.href = `/login?companyid=${0}`;
    //         window.location.href = `/newlogin`;
    //       }
    //       userLogout();
    //       removeRequestToken();
    //       cookies.remove("dingzhiBol");
    //       cookies.remove("jiluCompanyid");
    //     });
    //   });

    // user.dispatch({ type: "logout" });
  }
  // 关闭
  function onClose() {
    setQr(null);
    setImgShow(false);
    setPolling(null);
    window.clearInterval(time);
  }
  function bindingWxFn(force) {
    bindingWx({ force }).then(data => {
      setImgShow(true);
      setPolling(data.sceneId);
      setQr(data.qrCodeUrl);
      if (force) {
        setAlertBol(false);
        showMessage("info", "请您重新扫码");
      }
    });
  }
  useEffect(() => {
    // console.log(user, "adminUser");
    if (companyid && companyid * 1 !== 0) {
      setBindingBolType(1);
    }
    if (
      user.self.phoneBinding ||
      user.self.companySpecialAccount ||
      user.self.superAdmin ||
      window.location.href.indexOf("mymymanager") !== -1
    ) {
      setBndingBol(false);
    }
    if (imgShow && pollingData) {
      const timers = setInterval(() => {
        axios
          .get("/customer/bindingResultBySceneId", {
            params: { sceneId: pollingData }
          })
          .then(({ status, data }) => {
            if (!data.waiting) {
              if (data.needForce) {
                setAlertBol(true);
                setAlertBolType(1);
              } else {
                showMessage("success", "绑定成功！");
                onClose();
                user.dispatch({ type: "init" });
              }
              clearInterval(timers);
            }
          });
      }, 1000);
      setTime(timers);
    }
  }, [imgShow, pollingData]);
  if (user.self.qingyan) {
    arr = [];
  } else {
    arr = [];
    const cs = user.self.myCompanys;
    console.log("cookie输入", cookies.get("dingzhiBol"));
    if (
      cs &&
      cs.length > 1 &&
      !cookies.get("dingzhiBol") &&
      rightHost.includes(window.location.hostname)
    ) {
      arr.push({
        txt: "切换企业",
        onClick: () => {
          // 设置已选企业开关，可以再选企业
          cookies.set("noInWorkBol", true);
          setTo({ pathname: "/index" });
        }
      });
    }
    if (!user.self.companySpecialAccount) {
      // arr.push({
      //   txt: "个人信息",
      //   onClick: () => {
      //     setInfoAlertBol(true);
      //   }
      // });
    }
    if (user.self.phoneBinding && !user.self.weixinBinding) {
      // arr.push({
      //   txt: "绑定微信",
      //   onClick: () => {
      //     bindingWxFn(false);
      //   }
      // });
    }
    if (user.self.phoneBinding && !user.self.weixinBinding) {
      // arr.push({
      //   txt: "修改密码",
      //   onClick: () => {
      //     setVisible(true);
      //   }
      // });
    }
    if (!user.self.phoneBinding && user.self.weixinBinding) {
      // arr.push({
      //   txt: "绑定手机号",
      //   onClick: () => {
      //     setBndingBol(true);
      //     setBindingBolType(2);
      //   }
      // });
    }
  }
  if (user.self.adminRoles && user.self.adminRoles.length > 1) {
    arr.push({
      txt: "切换角色",
      onClick: () => {
        setRoleBol(true);
      }
    });
  }
  arr.push({
    txt: "退出",
    onClick: logout
  });

  const items = [];
  arr.forEach((item, i) => {
    items.push(
      <Menu.Item className="user-box-menu-item" key={item.txt}>
        <a href="javaScript:;" onClick={item.onClick}>
          {item.txt}
        </a>
      </Menu.Item>,
      <Menu.Divider key={item.txt + i} />
    );
  });
  items.pop();
  const { self } = user;
  const img = self.photo || self.weixinHeadimgurl || "/img/user-small.png";
  const name = self.name || self.weixinNickName || self.username;
  localStorage.setItem("userName", name);
  const roleData = [];
  if (user.self.adminRoles) {
    user.self.adminRoles.map(x => {
      if (
        (cookies.get("adminRoleId") * 1 || user.self.defaultRole) === x.roleId
      ) {
        roleData.push(x.name);
      }
      return roleData;
    });
  }

  // 绑定后自动跳转
  const onHrefs = () => {
    // alert(forwardUrl);
    if (forwardUrl) {
      if (forwardUrl) {
        if (forwardUrl) {
          const url = `${forwardUrl}${
            forwardUrl.indexOf("?") !== -1 ? "&" : "?"
          }token=${cookies.get("shorcuts")}`;

          window.location.href = url;
        }
      }
    } else {
      setAlertBol(false);
    }
  };

  return (
    <div>
      {/* 显示二维码 */}
      {imgShow && <ScreenQr imgUrl={qr} onClose={onClose} />}
      {visible && (
        <FogetPass
          visible={visible}
          onCacel={() => {
            setVisible(false);
          }}
          title="修改密码"
          user={user}
        />
      )}
      {/* 绑定风险提示弹窗 */}
      {alertBol && (
        <Alerts
          visible={alertBol}
          // onClose={() => {
          //   setAlertBol(false);
          //   if (user.self.weixinBinding) {
          //     setBndingBol(true);
          //   }
          // }}
          onClose={() => {
            if (bindingBol && bindingBolType === 2) {
              setBndingBol(true);
            }
            if (user.self.weixinBinding) {
              setBndingBol(true);
            }
            setAlertBol(false);
          }}
          onSure={() => {
            console.log(alertBolType);
            if (alertBolType !== 1) {
              const params = JSON.parse(sessionStorage.getItem("bindingData"));
              axios
                .post("/customer/bindingPhoneNumber?force=true", params)
                .then(({ status, data }) => {
                  setAlertBol(false);
                  if (!data.success) {
                    setBndingBol(true);
                    return;
                  }
                  showMessage("success", "绑定成功！");
                  // 成功后跳转
                  onHrefs();
                  user.dispatch({ type: "init" });
                });
            } else {
              bindingWxFn(true);
            }
          }}
          user={user}
          alertBolType={alertBolType}
        />
      )}
      {/* 修改个人信息弹窗 */}
      {infoAlertBol && (
        <InfoAlert
          visible={infoAlertBol}
          onClose={() => {
            if (infoAlertIsEdit) {
              setInfoAlertBol(false);
            }
          }}
          openPasAlert={() => {
            setVisible(true);
          }}
          openbindPhoneAlert={() => {
            setInfoAlertIsEdit(true);
            setBindingBolType(2);
            setBndingBol(true);
          }}
          openChangeNameeAlert={() => {
            setChangeNameBol(true);
          }}
          getData={user.self}
          onSure={() => {
            setInfoAlertBol(false);
            user.dispatch({ type: "init" });
          }}
          wx={() => {
            bindingWxFn(false);
          }}
        />
      )}
      {/*  显示修改名称 */}
      {changeNameBol && (
        <ChangeNameAlert
          visible={changeNameBol}
          onClose={() => {
            setChangeNameBol(false);
          }}
          getData={user.self}
          onSure={() => {
            setChangeNameBol(false);
            user.dispatch({ type: "init" });
          }}
        />
      )}

      {/* 绑定手机号 */}
      {bindingBol && bindingBolType === 2 && (
        <BindingAleft
          visible={bindingBol}
          onClose={() => {
            setBndingBol(false);
          }}
          getData={user.self}
          onSure={() => {
            setInfoAlertBol(false);
            user.dispatch({ type: "init" });
          }}
          user={user}
          bindingWxFn={bindingWxFn}
          openAlertBol={() => {
            setAlertBol(true);
            setAlertBolType(2);
          }}
          infoAlertIsEdit={infoAlertIsEdit}
        />
      )}
      {/* 管理员切换角色 */}
      {roleBol && (
        <ChangeRole
          visible={roleBol}
          onClose={() => {
            setRoleBol(false);
          }}
          dataSource={user.self}
          user={user}
          onSure={() => {
            setChangeNameBol(false);
            user.dispatch({ type: "init" });
          }}
        />
      )}
      {/* 认证弹窗 */}
      {rzBol && (
        <Rz
          visible={rzBol}
          onClose={() => {
            setrzBol(false);
          }}
          user={user}
          title={rzInfo.title}
          companyId={rzInfo.companyId}
        />
      )}
      <Dropdown overlay={<Menu className="user-box-menu">{items}</Menu>}>
        <div className="user-box">
          {!user.self.qingyan ? (
            <CommonIcon
              self={self}
              ys={{
                width: 40,
                height: 40,
                lineHeight: "40px"
              }}
              ys2={{ fontSize: 12 }}
            />
          ) : (
            <img className="tx" alt="userpicture" src={img} />
          )}
          <div style={{ marginLeft: 10 }}>
            <p>
              <span className="sp" title={name}>
                {name}
              </span>
              {/* 个人已认证 和未认证  失败 identify  1:认证中 2：驳回 3：通过图标显示  */}
              <a
                onClick={() => {
                  setRzInfo({
                    title: "个人认证",
                    companyId: user.self.id
                  });
                  setrzBol(true);
                }}
                className="gerenRz"
              >
                {!user.self.qingyan &&
                  (user.self.identify === 3 ? (
                    <img
                      style={{ cursor: "pointer" }}
                      src="/img/rzPass.png"
                      alt="认证"
                      title="个人已认证"
                      className="rz"
                    />
                  ) : (
                    <img
                      src="/img/rz.png"
                      alt="认证"
                      title="个人认证"
                      className="rz"
                    />
                  ))}
              </a>
            </p>
            {!user.self.qingyan && (
              <p>
                <span
                  className="sp"
                  title={
                    user.self.company
                      ? user.self.company.companyName
                      : !user.self.qingyan
                  }
                >
                  {!user.self.company && !user.self.qingyan}
                </span>
                {!user.self.company && !user.self.qingyan && (
                  <span className="companyInfo companyInfoGreen">
                    <img src="/img/infoTu.png" alt="图标" />
                    <span>个人用户</span>
                  </span>
                )}
                {user.self.company && (
                  <span
                    className={
                      user.self.company.identify === 3
                        ? "companyInfo companyInfoPass"
                        : "companyInfo"
                    }
                    title="企业认证"
                    onClick={() => {
                      if (user.self.company.owner === 1) {
                        setRzInfo({
                          title: "企业认证",
                          companyId: user.self.company.companyId
                        });
                        setrzBol(true);
                      } else if (user.self.company.identify !== 3) {
                        showMessage(
                          "info",
                          "企业认证需由企业超级管理员进行认证"
                        );
                      }
                    }}
                  >
                    <img src="/img/lou.png" alt="图标" />
                    <span>{user.self.company.companyName}</span>
                  </span>
                )}
              </p>
            )}

            {user.self.qingyan && (
              <p className="user-role" title={roleData.join("，")}>
                {roleData.join("，")}
              </p>
            )}
          </div>
          {redirect}
        </div>
      </Dropdown>
    </div>
  );
}
